import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './shared/styles/globals.css';
import App from './app';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>    
      <App />
    </QueryClientProvider>
  </StrictMode>
);
